import {
    CREATE_MIS_FORM_FIELD,
    createMisFormFieldSuccess,
    createMisFormFieldFailure,
    GET_MIS_FORM_FIELD_FILTERED,
    getMisFormFieldFilteredListSuccess,
    getMisFormFieldFilteredListFailure,
    MASTER_DATA_LIST,
    getMasterDataSuccess,
    getMasterDataFailure

} from './action';
import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS } from '../../constants';
import request from '../../components/Utils/httpHelper';
import { CORE_API,REPORT } from '../../config';


export function* createMisFormFieldSaga(action) {

    let requestUrl = `${CORE_API}/misfield/add`;
    try {
        const createMisFieldResp = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(createMisFormFieldSuccess(createMisFieldResp.data));
    } catch (err) {
        yield put(createMisFormFieldFailure(err.response));
    }
}


export function* createMisFormField() {
    yield takeLatest(CREATE_MIS_FORM_FIELD, createMisFormFieldSaga);
}


export function* getMisFormFieldFilteredListSaga(action) {

    let requestUrl = `${CORE_API}/misfield/list/${action.data.paginatedData.pageNumber}/${action.data.paginatedData.pageSize}/sort/${action.data.paginatedData.sortfield}/${action.data.paginatedData.sortDirection}`;
    try {
        const getMisFieldFilteredResp = yield call(request, requestUrl, { data: action.data.requestData, method: 'POST', headers: HTTP_HEADERS });
        yield put(getMisFormFieldFilteredListSuccess(getMisFieldFilteredResp.data));
    } catch (err) {
        yield put(getMisFormFieldFilteredListFailure(err.response));
    }
}


export function* getMisFormFieldFilteredList() {
    yield takeLatest(GET_MIS_FORM_FIELD_FILTERED, getMisFormFieldFilteredListSaga);
}

export function* getMasterDataSaga(action) {

    let requestUrl = `${REPORT}/masterdatakey/list`;
    try {
        const masterData = yield call(request, requestUrl, {method: 'GET', headers: HTTP_HEADERS });
        yield put(getMasterDataSuccess(masterData.data));
    } catch (err) {
        yield put(getMasterDataFailure(err.response));
    }
}


export function* getMasterData() {
    yield takeLatest(MASTER_DATA_LIST, getMasterDataSaga);
}